module.exports = __webpack_public_path__ + "img/7979fd9.jpg";